import { OrganizationCode } from 'merchandising-sdk';

export const environment = {
  production: false,
  organization: OrganizationCode.CI,
  is_online: true,
  assets_url: 'https://stmerchstagingci001.blob.core.windows.net/ci-assets',
  storage_token: 'sv=2022-11-02&ss=bf&srt=sco&sp=rwdlactfx&se=2026-09-24T22:26:46Z&st=2024-09-24T14:26:46Z&spr=https,http&sig=TwH56%2FUc6jNnkZ6lccFTgNggi1LAoxKrzGENrmKP%2FhI%3D',
  local_db_name: 'merchandising.db',
  azure_blob_sas_url: ``,
  azure_container: `ci-assets`
};